import React, { Component } from "react";

export default function Footer(){
    return(
        <>
        <p className="text-muted p-3">© 2024 Connects</p>
        </>
    )
}